export default {
  options: {
    'units': {
      'kilometers': 'kilométer',
      'meters': 'méter',
      'miles': 'mérföld'
    },
    'areUnits': {
      'sqKms': 'km²',
      'hectare': 'hektár',
      'sqMeters': 'm²'
    }
  }
}
